<div class="main-section congratulation-page text-center">
    <img src="https://images.5paisa.com/SPOT/5p_loan/congrats.gif" />
    <h4>{{h4_context}}</h4>
    <!-- <p>{{p_context_1}}</p> -->
    <P>
        Your NSE & BSE Derivatives segments will be activated within 48 hours.<br/>Stay tuned—your F&O trading journey is about to begin with 5paisa FNO360.
    </P>
    <!-- <p>{{p_context_2}}</p> -->
</div>